import { UnitTransferCheckVerdictEnumType } from '__generated__/graphql';

export default function unitTransferCheckVerdictToReadable(
  verdict: UnitTransferCheckVerdictEnumType
): {
  label: string;
  color: string;
} {
  switch (verdict) {
    case UnitTransferCheckVerdictEnumType.Pass:
      return { label: 'Pass', color: 'green' };
    case UnitTransferCheckVerdictEnumType.Fail:
      return { label: 'Fail', color: 'red' };
    case UnitTransferCheckVerdictEnumType.Unclear:
      return { label: 'Unclear', color: 'amber' };
    default:
      return { label: verdict, color: 'gray' };
  }
}
